import MuiTab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../app/theme';

const styles = makeStyles(
  theme => ({
    root: {
      ...theme.typography.body1,
      fontWeight: 'normal',
      lineHeight: '18px',
      padding: '15px 16px',
      color: color.$11,
      minWidth: 'auto',
      textTransform: 'unset',
      '&:hover': {
        color: color.$10,
      },
    },
    selected: {
      color: color.$3,
    },
  }),
  'Tab',
);

const Tab = props => {
  const { ...others } = props;
  const classes = styles();

  return <MuiTab classes={classes} {...others} />;
};

export default Tab;
